export const DEFAULT_DELIVERY_TIME_UNIT = 'minutes'
export const DEFAULT_DELIVERY_DELAY: number = 0